import React from 'react'

export const FacebookIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44.62" height="44.619" viewBox="0 0 44.62 44.619">
      <path id="facebook-icon" fill="#D7DF23" d="M44.62-.001v44.62H30.87v-17.29h5.82l.77-6.77h-6.59v-5.08c0-.03.011-2.561 3.141-2.561h3.72v-5.97s-2.92-.3-5.271-.3c-.319 0-3.909 0-6.38 2.46-2.46 2.46-2.14 6.37-2.14 6.37v5.08h-5.91v6.77h5.91v17.29H0V-.002h44.62z" />
    </svg>
  )
}
